import { PickingBatchViewService } from 'common/data';
import { BaseStore } from 'core/stores';

class PickingBatchViewStore extends BaseStore {
	constructor(rootStore) {
		super(new PickingBatchViewService(rootStore.app.baasic.apiClient));
	}
}

export default PickingBatchViewStore;



// WEBPACK FOOTER //
// ./src/modules/picking-batch-view/stores/PickingBatchViewStore.js